// @flow

import React from "react";
import cx from "classnames";

import styles from "./Status.scss";
import { GREEN, GREY, RED, statuses, YELLOW } from "../../data/statuses";

type Color = typeof YELLOW | typeof GREEN | typeof GREY | typeof RED;

type StatusProps = {
  status: string,
  site: string,
  renderAsBlock: boolean
};

const mapColorToClassName = (color: Color) =>
  cx(styles.status, {
    [styles.red]: color === RED,
    [styles.green]: color === GREEN,
    [styles.yellow]: color === YELLOW,
    [styles.grey]: color === GREY
  });

const Status = ({ site, status, renderAsBlock }: StatusProps) => {
  const option = statuses[site][status] || { color: GREY, label: "" };

  return renderAsBlock ? (
    <div className={styles.block}>
      <div className={cx(styles.colorWindow, mapColorToClassName(option.color))} />
      <div className={styles.label}>{option.label}</div>
    </div>
  ) : (
    <span data-testid="inquiryStatus" className={mapColorToClassName(option.color)}>
      {option.label}
    </span>
  );
};

Status.defaultProps = {
  renderAsBlock: false
};

export default Status;
